module.exports = __webpack_public_path__ + "static/yalelogo-acdfeaac472c357529b4be44b5863308.png";